<dynamic-form
  [apiName]="apiName"
  [group]="formGroup"
  [label]="label"
  [areaName]="areaName"
  [model]="model"
  [erroremessage]="erroremessage"
  savingLabel="درحال قیمت گذاری"
  saveLabel="قیمت گذاری"
  [columns]="columns"
  (valueChangeWithName)="onChanged($event)"
  (cancelChange)="cancel()"
  (submitChange)="save()">
  <div class="fcContent">
    <ssg-select
      *ngIf="formGroup"
      name="BranchIds"
      [multiple]="true"
      [group]="formGroup"
      label="شعبه"
      limitSelection="5"
      [hasCheckBox]="true"
      [hasSelectAll]="true"
      userClass="small"
      dropdownPosition="auto"
      apiName="Branch/ReadLookUp"
      textFieldName="Title"
      valueFieldName="Id"
      (valueChange)="onChanged($event)">
    </ssg-select>
    <ssg-select
      *ngIf="formGroup"
      name="WarehouseIds"
      [multiple]="true"
      [group]="formGroup"
      label="انبار"
      userClass="small"
      apiName="Warehouse/ReadLookUp"
      textFieldName="Title"
      valueFieldName="Id"
      limitSelection="5"
      dropdownPosition="auto"
      [hasCheckBox]="true"
      [hasSelectAll]="true"
      (valueChange)="onChanged($event)">
    </ssg-select>
  </div>
  <ng-container class="content">
    <kgrid
      [apiName]="apiName"
      [areaName]="areaName"
      [label]="label"
      [noToolBar]="true"
      [groupable]="false"
      [filtering]="false"
      [name]="apiName"
      pathPreFix="INV"
      [isMulti]="false"
      [dataList]="dataList"
      (onDataStateChanged)="setDate()"
      [columns]="voucherColumns"
      [isAdd]="false"
      [isEdit]="false"
      [isDelete]="false"
      [isMulti]="false">
    </kgrid>
  </ng-container>
</dynamic-form>
